import { combineReducers, configureStore } from '@reduxjs/toolkit';
import watcherSaga from "./sagas";
import createSagaMiddleware from 'redux-saga';
import sellerRegSlice from './slices/sellerRegSlice';
import sellerProfileSlice from './slices/sellerProfileSlice';
import FAQSlice from './slices/FAQSlice';
import subSellerSignUpSlice from './slices/subSellerSignUpSlice';
import statusGraphSlice from './slices/statusGraphSlice';
import questionnaireSlice from './slices/questionnaireSlice';
import notificationSlice from './slices/notificationSlice';
import mySettingSlice from './slices/mySettingSlice';
import staticPagesSlice from './slices/staticPagesSlice';
import apiCredentialSlice from './slices/apiCredentialSlice';
import userSlice from './slices/userSlice';
import loaderSlice from './slices/loaderSlice'
import backOfficeSlice from './slices/backOfficeSlice';


const reducer = combineReducers({
  sellerReg: sellerRegSlice,
  sellerProfile: sellerProfileSlice,
  statusGraph: statusGraphSlice,
  subSellerSignUp: subSellerSignUpSlice,
  faq: FAQSlice,
  questionnaire: questionnaireSlice,
  notification: notificationSlice,
  mySetting: mySettingSlice,
  staticPages: staticPagesSlice,
  apiCredential : apiCredentialSlice,
  user : userSlice,
  apiLoader: loaderSlice,
  backOffice : backOfficeSlice
});

const sagaMiddleware = createSagaMiddleware();

const middleware: any = (getDefaultMiddleware: any) => [
  ...getDefaultMiddleware({ thunk: false }),
  sagaMiddleware,
];


const store = configureStore({
  reducer,
  middleware,
});

sagaMiddleware.run(watcherSaga);


export default store;